module.exports = __webpack_public_path__ + "img/academy-settings.36dd5c51.svg";